import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LogUsuarioService } from 'src/services/log-usuario.service';
import { UsuarioService } from 'src/services/usuario.service';
import { PermissoesService } from 'src/services/permissoes.service';
import * as moment from 'moment';

@Component({
    selector: 'app-log-usuario',
    templateUrl: './log-usuario.component.html',
    styleUrls: ['./log-usuario.component.scss'],
    standalone: false
})
export class LogUsuarioComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  loading: boolean = false;
  
  // Filtros
  usuarioSelecionado: number | null = null;
  dataInicial: Date | null = null;
  dataFinal: Date | null = null;
  tabelaAlterada: string | null = null;
  
  // Dropdowns
  dropDownUsuarios: any[] = [];
  dropDownTabelas: any[] = [
    { label: 'Sistema', value: 'sistema' },
    { label: 'Usuários', value: 'users' },
    { label: 'Arquivos', value: 'arquivos' },
    { label: 'Descodificação', value: 'descodificacao' },
    { label: 'Emails Lista Grupos', value: 'emails_lista_grupos' },
    { label: 'Estação Grupos', value: 'estacao_grupos' },
    { label: 'Estações', value: 'estacoes' },
    { label: 'Grupo Emails', value: 'grupo_emails' },
    { label: 'Grupo Usuário', value: 'grupo_usuario' },
    { label: 'Monitoramento', value: 'monitoramento' },
    { label: 'Permissão', value: 'permissao' },
    { label: 'Pessoa', value: 'pessoa' },
    { label: 'Retrive', value: 'retrive' },
    { label: 'Sensores', value: 'sensores' },
    { label: 'Tipo Coleta', value: 'tipo_coleta' },
    { label: 'Tipo Variável', value: 'tipo_variavel' },
    { label: 'Configuração Coleta', value: 'configuracao_coleta' },
    { label: 'Reintegração', value: 'reintegracao' },
    { label: 'Recarregamento de dados', value: 'recarregamento_dados' },
    { label: 'Credencial do integrador', value: 'integrador_credencial' }
  ];
  
  // Paginação
  currentPage: number = 1;
  perPage: number = 50;
  totalRecords: number = 0;
  first: number = 0;
  
  // Flag para controlar se já foi filtrado
  dadosFiltrados: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  constructor(
    private logUsuarioService: LogUsuarioService,
    private usuarioService: UsuarioService,
    private messageService: MessageService,
    protected permissaoService: PermissoesService,
  ) {}

  ngOnInit(): void {
    this.carregarUsuarios();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  carregarUsuarios(): void {
    this.usuarioService.listarUsuarios().subscribe({
      next: (res) => {
        const usuarios = res.data || res || [];
        this.dropDownUsuarios = usuarios.map((item: any) => ({
          label: item.name || `Usuário ${item.id}`,
          value: item.id
        }));
      },
      error: (err) => {
        console.error('Erro ao carregar usuários:', err);
      }
    });
  }

  filtrar(): void {
    this.loading = true;
    this.currentPage = 1;
    this.first = 0;
    
    const filtros: any = {
      per_page: this.perPage,
      page: this.currentPage
    };

    if (this.usuarioSelecionado) {
      filtros.usuario_id = this.usuarioSelecionado;
    }
    if (this.dataInicial) {
      filtros.data_inicial = moment(this.dataInicial).format('YYYY-MM-DD');
    }
    if (this.dataFinal) {
      filtros.data_final = moment(this.dataFinal).format('YYYY-MM-DD');
    }
    if (this.tabelaAlterada) {
      filtros.tabela_alterada = this.tabelaAlterada;
    }

    this.logUsuarioService.listar(filtros).subscribe({
      next: (res) => {
        this.data = res.data || [];
        this.totalRecords = res.total || 0;
        this.loading = false;
        this.dadosFiltrados = true;
        setTimeout(() => {
          this.calculateScrollHeight();
        }, 200);
        
        if (this.data.length === 0) {
          this.messageService.add({ 
            severity: 'info', 
            summary: 'Informação', 
            detail: 'Nenhum registro encontrado para os filtros selecionados' 
          });
        }
      },
      error: (err) => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Erro', 
          detail: 'Erro ao carregar logs' 
        });
        this.loading = false;
        this.dadosFiltrados = true;
      }
    });
  }

  onPageChange(event: any): void {
    if (!this.dadosFiltrados) {
      return;
    }

    // Para lazy load, o evento tem first e rows
    const page = (event.first / event.rows) + 1;
    this.first = event.first;
    this.perPage = event.rows;
    this.currentPage = page;
    
    const filtros: any = {
      per_page: this.perPage,
      page: this.currentPage
    };

    if (this.usuarioSelecionado) {
      filtros.usuario_id = this.usuarioSelecionado;
    }
    if (this.dataInicial) {
      filtros.data_inicial = moment(this.dataInicial).format('YYYY-MM-DD');
    }
    if (this.dataFinal) {
      filtros.data_final = moment(this.dataFinal).format('YYYY-MM-DD');
    }
    if (this.tabelaAlterada) {
      filtros.tabela_alterada = this.tabelaAlterada;
    }

    this.loading = true;
    this.logUsuarioService.listar(filtros).subscribe({
      next: (res) => {
        this.data = res.data || [];
        this.totalRecords = res.total || 0;
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Erro', 
          detail: 'Erro ao carregar logs' 
        });
        this.loading = false;
      }
    });
  }

  formatarDataHora(dataHora: string): string {
    return moment(dataHora).format('DD/MM/YYYY HH:mm:ss');
  }

  getNomeUsuario(item: any): string {
    if (item.usuario && typeof item.usuario === 'object') {
      return item.usuario.name || 'N/A';
    }
    return 'N/A';
  }

  getEmailUsuario(item: any): string {
    if (item.usuario && typeof item.usuario === 'object') {
      return item.usuario.email || 'N/A';
    }
    return 'N/A';
  }

}

